"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = __importDefault(require("./Button"));
function ActionButtons(props) {
    const { onDone, onCancel, doneLabel = 'Apply', cancelLabel = 'Cancel', style = {}, } = props;
    return ((0, jsx_runtime_1.jsxs)("div", { style: { margin: '0 10px', display: 'flex', ...style }, children: [(0, jsx_runtime_1.jsx)(Button_1.default.Done, { onClick: onDone, style: style?.flexDirection === 'row-reverse'
                    ? {
                        marginLeft: '10px',
                    }
                    : {}, children: doneLabel }), (0, jsx_runtime_1.jsx)(Button_1.default.Danger, { fill: "outline", onClick: onCancel, style: !style.flexDirection || style.flexDirection === 'row'
                    ? {
                        marginLeft: '10px',
                    }
                    : {}, children: cancelLabel })] }));
}
exports.default = ActionButtons;
